<template>

    <v-layout wrap>
        <v-flex xs12>
            <v-card color="grey lighten-2" class="kim-card">

                <v-toolbar flat color="transparent" >
                        <v-toolbar-title>Configuración</v-toolbar-title>
                </v-toolbar>

                <v-list two-line subheader color="secondary">

                    <v-list-item

                            v-if="internal"
                    >
                        <v-list-item-avatar>
                            <v-icon>fa-coffee</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>Cita sin costo</v-list-item-title>
                            <v-list-item-subtitle>Ej. Para controles, ofertas, etc.</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-switch
                                    v-model="free" />
                        </v-list-item-action>

                    </v-list-item>


                    <v-list-item

                            v-if="vcAllowed"
                    >
                        <v-list-item-avatar>
                            <v-icon>fa-video</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>Cita por Video</v-list-item-title>
                            <v-list-item-subtitle>Se enviará un link antes de la cita</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-switch
                                v-model="vc" />
                        </v-list-item-action>

                    </v-list-item>

                </v-list>

            </v-card>
        </v-flex>
    </v-layout>

</template>

<script>
    export default{
        props:{
            internal:{
                type: Boolean,
                default: false
            },
            vcAllowed:{
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                free: false,
                vc: false

            }
        },
        watch:{
            free(val){
                this.$emit('change:free', val)
            },
            vc(val){
                this.$emit('change:vc', val)
            }
        }
    }
</script>
